import clsx from "clsx"
import { useTranslation } from "react-i18next"
import { getProductName } from "@/utils/product-name"
import { Icon } from "../icons/Icon"
import { Spinner } from "../ui/Spinner"
import { useAtom } from "jotai"
import { Dialog } from "@/components/ui/Dialog"
import { pendingFolderPermissionsAtom } from "@/store/project/projects-state"
import permissionSvgUrl from "@assets/permission.svg?url"

export function PermissionsDialog() {
	const { t } = useTranslation("components")
	const [hasWritePermission] = useAtom(pendingFolderPermissionsAtom)

	const renderPermission = (props: {
		isActive: boolean
		hasPermission: boolean
		text: string
	}) => {
		return (
			<div
				className={clsx(
					props.isActive ? "opacity-100" : "opacity-50",
					"flex w-full flex-row justify-between text-sm text-base-300",
				)}
			>
				<label>{props.text}</label>
				{props.isActive && !props.hasPermission && <Spinner size={16} />}
				{props.hasPermission && (
					<Icon
						className="size-4 rounded-full bg-green-500 p-0.5 text-base-800"
						name="check"
						size={14}
					/>
				)}
			</div>
		)
	}

	return (
		<Dialog trackingViewName="permissions_dialog" disableClose>
			<div className="flex w-[512px] flex-col space-y-6">
				<img src={permissionSvgUrl} className="h-auto w-full rounded-md" />
				<div className="flex w-full text-md">
					{t("permissionsDialog.needsPermission", { productName: getProductName() })}
				</div>
				<div className="flex w-full flex-col space-y-2">
					{renderPermission({
						isActive: true,
						hasPermission: hasWritePermission,
						text: t("permissionsDialog.clickEditFiles"),
					})}
				</div>
			</div>
		</Dialog>
	)
}
